import styled from '@emotion/styled'
import {DatePicker} from '@mui/x-date-pickers'

export const StyledDatePicker = styled(DatePicker)(({theme}) => ({
  width: '100%',
  '.MuiOutlinedInput-root': {
    border: `1px solid ${theme.palette.common.lightBlue}`,
    borderRadius: '4px'
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.common.white,
    opacity: 0.8
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.common.grey6
  }
}))
